import * as React from "react";

const SvgIcnResize = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M6.144 9.862A.519.519 0 016 9.494a.53.53 0 01.036-.195.47.47 0 01.276-.264A.6.6 0 016.517 9h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104zm0 3A.519.519 0 016 12.494a.53.53 0 01.036-.195.47.47 0 01.276-.264.6.6 0 01.205-.035h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104zm0 3A.519.519 0 016 15.494a.53.53 0 01.036-.195.47.47 0 01.276-.264.6.6 0 01.205-.035h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnResize;
